import * as React from "react";
import { useLocation, useLink } from "@grandvisionhq/frk-routing";
import { Types } from "@grandvisionhq/graphql";
import { ToastProvider } from "@grandvisionhq/iris-ui";
import { useDispatchTrackClickEvent } from "@grandvisionhq/svc-tealium/events";
import { appendQueryParamToUrl } from "@grandvisionhq/utils";
import { useCreatePaypalPaymentEvents } from "../../../../../../../../hooks/paypal/hooks/paypal/use-create-paypal-payment-events.js";
import { useIsExpressPaypalSupportedForCart } from "../../../../../../../../hooks/hooks/use-is-express-paypal-supported.js";
import { PaypalActionButtonContainer } from "./PaypalActionButtonContainer.js";
import { PaypalPaymentEventsProvider } from "../../../../../../../../context/Paypal/context/Paypal/PaypalPaymentEventsContext.js";
import { ExpressPaymentMethod, PaymentMethod } from "../../../../../../../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
const PaypalExpressButton = ({
  cartId,
  cartHash,
  isOrderInProgress = false,
  setIsOrderInProgress,
  onClickHandler
}) => {
  const [referenceId, setReferenceId] = React.useState(void 0);
  const [paymentToken, setPaymentToken] = React.useState(void 0);
  const dispatchTealiumTrackEvent = useDispatchTrackClickEvent();
  const { replace } = useLocation();
  const expressCheckoutLink = useLink({
    route: "express-overview",
    params: {
      type: ExpressPaymentMethod.PAYPAL,
      cartId,
      cartHash,
      referenceId: "",
      paymentToken: ""
    }
  });
  React.useEffect(() => {
    if (referenceId && paymentToken && expressCheckoutLink?.href) {
      setIsOrderInProgress?.(true);
      replace(
        appendQueryParamToUrl(expressCheckoutLink.href, {
          referenceId,
          paymentToken
        })
      );
    }
  }, [replace, referenceId, paymentToken, expressCheckoutLink?.href]);
  const handleOnClick = React.useCallback(() => {
    dispatchTealiumTrackEvent({
      data_element_id: "Summary_PayPalCheckout",
      data_description: "checkout_with_paypal"
    });
    onClickHandler && onClickHandler(PaymentMethod.PAYPAL);
  }, [dispatchTealiumTrackEvent, onClickHandler]);
  const paypalPaymentEvents = useCreatePaypalPaymentEvents({
    cartId,
    // Subscription is always disabled for express checkout
    hasSubscription: false,
    onPaymentAuthorization: setReferenceId,
    onPaymentTokenReceive: setPaymentToken,
    checkoutType: Types.CheckoutType.EXPRESS,
    onClick: handleOnClick
  });
  return /* @__PURE__ */ React.createElement(PaypalPaymentEventsProvider, { orderType: "regular", ...paypalPaymentEvents }, /* @__PURE__ */ React.createElement(PaypalActionButtonContainer, { isDisabled: isOrderInProgress }));
};
const PaypalExpressButtonContainer = (props) => {
  const { cartId } = props;
  const { isExpressPaypalSupported, loading, error } = useIsExpressPaypalSupportedForCart(cartId);
  if (error || !isExpressPaypalSupported || loading) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(ToastProvider, { closeButtonDescription: "close paypal message", defaultTimeout: 6e3 }, /* @__PURE__ */ React.createElement(PaypalExpressButton, { ...props }));
};
export {
  PaypalExpressButtonContainer
};
//# sourceMappingURL=PaypalExpressButton.js.map
